import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  texts: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().navbar;
  }
  
  setLanguage(language: string): void {
    this.langServ.setLanguage(language);
    if (typeof location !== 'undefined') {
      location.reload(); // Reload the page to apply the new language
    }
  }

  getLanguage(): string {
    return this.langServ.getLanguage();
  }

}
